export default class FoulingData {
    constructor(
        polynomials,
        meanChangeAdj,
        foulingConfig,
        log
    ) {
        this.polynomials = polynomials;
        this.meanChangeAdj = meanChangeAdj;
        this.foulingConfig = foulingConfig;
        this.log = log;
    }
}